import { inject, observer } from "mobx-react";
import { computed } from "mobx";

import { Dialog } from "primereact/dialog";

import MassActions from "../../components/Modals/MassActions";
import AddGeography from "../../components/Modals/AddGeography";
import Logger from "../../components/Modals/Logger";
import CopyCompany from "../../components/Modals/CopyCompany";
import CloneCompany from "../../components/Modals/CloneCompany";
import UploadSortsFile from "../../components/Modals/UploadSortsFile";

import "./style.scss";

const Modals = inject("mainStore")(
    observer(({ mainStore }) => {
        const modal = computed(() => mainStore.getMainStore("modal")).get();

        const type = modal && modal.type ? modal.type : false;
        const title = modal && modal.title ? modal.title : "";

        const handleHide = () => {
            mainStore.setMainStore("modal", false);
        };

        const Specified = type && modals[type] ? modals[type] : null;

        return (
            !!Specified && (
                <Dialog className={`modal modal_${type}`} visible header={title} onHide={handleHide} showHeader={!!title} dismissableMask>
                    <Specified data={modal} />
                </Dialog>
            )
        );
    }),
);

export default Modals;

const modals = {
    massActions: MassActions,
    addGeography: AddGeography,
    logger: Logger,
    copyCompany: CopyCompany,
    cloneCompany: CloneCompany,
    uploadSortsFile: UploadSortsFile,
};
